import { render, staticRenderFns } from "./AddType.vue?vue&type=template&id=ffc065b4&scoped=true"
import script from "./AddType.vue?vue&type=script&lang=js"
export * from "./AddType.vue?vue&type=script&lang=js"
import style0 from "./AddType.vue?vue&type=style&index=0&id=ffc065b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc065b4",
  null
  
)

export default component.exports